// Etkinlikler (takvim) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'events.calendar';

export const eventsCalendarGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Etkinlikler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'İşletmenizin etkinliklerini, özel günlerini ve günlük notlarını tek takvimde tutarsınız. Solda küçük takvim, yaklaşan etkinlikler ve özel etkinlikler; sağda büyük takvim bulunur. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Takvim düğmeleri'),
    list: t(`${G}.regions.list`, 'Küçük takvim ve özel etkinlikler'),
    form: t(`${G}.regions.form`, 'Büyük takvim'),
    footer: t(`${G}.regions.footer`, 'Etkinlik penceresi'),
  },
  steps: [
    {
      region: 'list',
      title: t(`${G}.s1.title`, '1. Günü seçin'),
      text: t(`${G}.s1.text`, 'Soldaki küçük takvimde bir güne tıklayınca büyük takvim o güne gider; "Bugün" düğmesi bugüne döner. Büyük takvimin üstündeki Ay, Hafta, Gün, Yıl, Liste düğmeleri görünümü değiştirir. Yıl görünümünde bir güne tıklayınca o ayın görünümü açılır.'),
      tips: [
        t(`${G}.s1.tip1`, '"Yaklaşan Etkinlikler" bölümü önümüzdeki bir ay içindeki ilk 3 etkinliği gösterir.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Etkinlik ekleyin'),
      text: t(`${G}.s2.text`, 'Büyük takvimde bir güne tıklayın ya da fareyle birkaç gün / saat aralığını seçin; "Yeni Etkinlik Ekle" penceresi açılır. Etkinlik Başlığı zorunludur. Başlangıç Zamanı ve Bitiş Zamanı girin (bitiş başlangıçtan sonra olmalı), isterseniz "Tüm Gün" ve Notlar ekleyin, sonra Kaydet\'e basın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Ay görünümünde bir güne tıklarsanız başlangıç saati 12:00 olarak gelir.'),
        t(`${G}.s2.tip2`, '"Özel Etkinlik Seç (Opsiyonel)" alanıyla etkinliği bir özel etkinliğe bağlayabilirsiniz; etkinlik o özel etkinliğin renginde görünür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Her yıl tekrarlanan etkinlikler'),
      text: t(`${G}.s3.text`, 'Doğum günü, kuruluş yıl dönümü gibi günler için "Her Yıl Tekrarla" kutusunu işaretleyin. Etkinlik her yıl aynı gün ve saatte takvimde yeniden görünür; tekrar kopyası mor renkte ve başında 🔄 işaretiyle gösterilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Tekrar kopyası sürüklenerek taşınamaz; değişiklik için asıl etkinliği düzenleyin.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Düzenleyin, taşıyın, silin'),
      text: t(`${G}.s4.text`, 'Takvimdeki bir etkinliğe tıklayınca "Etkinlik Düzenle" penceresi açılır; Güncelle ile kaydedin. Etkinliği fareyle başka bir güne sürükleyerek tarihini değiştirebilirsiniz. "Etkinliği Sil" onay sorar; silinen etkinlik geri alınamaz.'),
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Özel etkinlikler ve toplu ekleme'),
      text: t(`${G}.s5.text`, '"Özel Etkinlik Ekle" ile kampanya, bayram gibi bir etkinlik türü oluşturursunuz: Etkinlik Adı zorunlu, Açıklama ve Etkinlik Rengi seçilir. "Toplu Etkinlik Ekle" ile birden fazla etkinliği tek seferde girersiniz; isterseniz hepsini aynı özel etkinliğe bağlarsınız.'),
      tips: [
        t(`${G}.s5.tip1`, 'Soldaki "Özel Etkinlikler" listesinde anahtarı kapatırsanız o özel etkinliğe bağlı etkinlikler takvimde gizlenir; açınca yeniden görünür.'),
        t(`${G}.s5.tip2`, 'Satırdaki (i) düğmesi detayları ve bağlı etkinlik sayısını gösterir. Bağlı etkinliği olan özel etkinlik silinemez; önce bağlı etkinlikleri silin.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Ajanda ile günlük notlar'),
      text: t(`${G}.s6.text`, '"Ajanda" düğmesi seçili gün için not sayfasını açar. "Yeni Not Ekle" ile not yazın, kalem simgesiyle düzenleyip Kaydet\'e basın, çöp kutusuyla silin. Takvime dönmek için geri düğmesini kullanın.'),
    },
  ],
});
